module.exports = __webpack_public_path__ + "static/media/moving.045e945b.png";